// Centralized API configuration
export const API_BASE = 
  process.env.REACT_APP_API_URL || 
  import.meta.env?.VITE_API_URL || 
  'https://factoelectrical.com/api';

// Exporting as default for easier imports if needed
export default API_BASE;
